export const LANDING_URL = "https://expense.aero/";
